var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLightswitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.566
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.702,
    filter: "url(#lightswitch_svg__filter0_f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 32,
    r: 15,
    fill: "#80AFE5"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.557,
    filter: "url(#lightswitch_svg__filter1_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9.5,
    y: 4.5,
    width: 120,
    height: 55,
    rx: 27.5,
    stroke: "#7DABE0",
    strokeWidth: 3
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "lightswitch_svg__filter0_f",
    x: 59.563,
    y: 11.563,
    width: 40.873,
    height: 40.873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.718,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lightswitch_svg__filter1_f",
    x: -13.718,
    y: 0.282,
    width: 128.437,
    height: 63.437,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.359,
    result: "effect1_foregroundBlur"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTE1IiBoZWlnaHQ9IjY0IiB2aWV3Qm94PSIwIDAgMTE1IDY0IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBvcGFjaXR5PSIwLjU2NjMxMyI+CjxnIG9wYWNpdHk9IjAuNzAxNjYiIGZpbHRlcj0idXJsKCNmaWx0ZXIwX2YpIj4KPGNpcmNsZSBjeD0iODAiIGN5PSIzMiIgcj0iMTUiIGZpbGw9IiM4MEFGRTUiLz4KPC9nPgo8ZyBvcGFjaXR5PSIwLjU1NjU3MSIgZmlsdGVyPSJ1cmwoI2ZpbHRlcjFfZikiPgo8cmVjdCB4PSItOS41IiB5PSI0LjUiIHdpZHRoPSIxMjAiIGhlaWdodD0iNTUiIHJ4PSIyNy41IiBzdHJva2U9IiM3REFCRTAiIHN0cm9rZS13aWR0aD0iMyIvPgo8L2c+CjwvZz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZiIgeD0iNTkuNTYzNCIgeT0iMTEuNTYzNCIgd2lkdGg9IjQwLjg3MzEiIGhlaWdodD0iNDAuODczMSIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9IkJhY2tncm91bmRJbWFnZUZpeCIgcmVzdWx0PSJzaGFwZSIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyLjcxODI4IiByZXN1bHQ9ImVmZmVjdDFfZm9yZWdyb3VuZEJsdXIiLz4KPC9maWx0ZXI+CjxmaWx0ZXIgaWQ9ImZpbHRlcjFfZiIgeD0iLTEzLjcxODMiIHk9IjAuMjgxNzE4IiB3aWR0aD0iMTI4LjQzNyIgaGVpZ2h0PSI2My40MzY2IiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+CjxmZUZsb29kIGZsb29kLW9wYWNpdHk9IjAiIHJlc3VsdD0iQmFja2dyb3VuZEltYWdlRml4Ii8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9InNoYXBlIi8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjEuMzU5MTQiIHJlc3VsdD0iZWZmZWN0MV9mb3JlZ3JvdW5kQmx1ciIvPgo8L2ZpbHRlcj4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgLightswitch as ReactComponent };